import { styled } from '@mui/material/styles';

const VisuallyHiddenInput = styled('input')({
    opacity: 0,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
});

export default VisuallyHiddenInput;
